import { render } from "./PaymentFailed.vue?vue&type=template&id=ff53437c&scoped=true"
import script from "./PaymentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&lang=js"

import "./PaymentFailed.vue?vue&type=style&index=0&id=ff53437c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff53437c"]])

export default __exports__